module.exports = __webpack_public_path__ + "img/mbd-banner.9863a77f.jpg";